<template>
  <div>
    <b-modal
      v-if='removeImageFromList'
      v-model='removeImageFromList'
      ok-title='Tak'
      cancel-title='Nie'
      title='Uwaga'
      @ok='() => actions.handleRemoveImageFromList(flatPage.id, item.id, imageToRemove.id)'
      centered
    >
      Czy usunąć obraz z listy ?
    </b-modal>

    <b-row class='mt-2'>
      <b-col>
        <h4 v-if='item && item.type'>{{item.type.toUpperCase()}}</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button
          variant='outline-primary'
          @click='() => actions.handleAddImageToList(flatPage.id, item.id)'
        >
          Dodaj obraz do listy
        </b-button>
      </b-col>          
    </b-row>

    <b-row class='mt-3'>
      <b-col cols='4'>
        <label class='mt-3 mb-0'>Odstęp</label>
        <b-form-input
          type='number'
          v-model='item.margin'
          @click='(e) => actions.handleImageListValueChanged(flatPage.id, item.id, "margin", e)'
        />
      </b-col>
      <b-col cols='4'>
        <label class='mt-3 mb-0'>Przewijanie</label>
        <b-form-checkbox
          class='mt-1'
          v-model='item.scrolling'
          @input='(e) => actions.handleImageListValueChanged(flatPage.id, item.id, "scrolling", e)'
          value="1"
          unchecked-value="0"
        />
      </b-col>
      <b-col cols='4'>
        <label class='mt-3 mb-0'>Centrowanie</label>
        <b-form-checkbox
          class='mt-1'
          v-model='item.center'
          @input='(e) => actions.handleImageListValueChanged(flatPage.id, item.id, "center", e)'
          value="1"
          unchecked-value="0"
        />
      </b-col>
    </b-row>

    <b-row class='mt-3'>
      <b-col cols='4' v-for='(image, i) in item.value.images' :key='i' class='mt-0 pr-0 pl-0 pb-0 pt-0'>
        <div class='image-container'>
          <b-row>
            <b-col>
              <b-button-group size='sm' class='float-right'>
                <b-button variant="danger" @click='() => { imageToRemove = image; removeImageFromList = true; }'><b-icon-trash /></b-button>

                <b-button
                  variant="info"
                  @click='() => { actions.handleMoveImageLeftInImageList(flatPage.id, item.id, image.id) }'
                ><b-icon-caret-left-fill /></b-button>

                <b-button
                  variant="success"
                  @click='() => { actions.handleMoveImageRightInImageList(flatPage.id, item.id, image.id) }'
                ><b-icon-caret-right-fill /></b-button>
              </b-button-group>  
            </b-col>
          </b-row>

          <b-row v-if='imageSrc(image)' class='mt-2'>
            <b-col class='text-center image-wrapper'>
              <img :src='imageSrc(image)' style='max-width: 150px; max-height: 120px; background: silver;'/>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <label class='mt-3 mb-0'>Wysokość</label>
              <b-form-input
                type='number'
                v-model='image.height'
                @input='(e) => actions.handleImageListImagePropChanged(flatPage.id, item.id, image.id, "height", e)'
              />
            </b-col>
          </b-row>  
          <b-row>
            <b-col>
              <label class='mt-3 mb-0'>Szerokość (%)</label>
              <b-form-input
                type='number'
                v-model='image.percentWidth'
                @input='(e) => actions.handleImageListImagePropChanged(flatPage.id, item.id, image.id, "percentWidth", e)'
              />
            </b-col>
          </b-row>  
          <b-row>
            <b-col>
              <label class='mt-3 mb-0'>Margines dolny</label>
              <b-form-input
                type='number'
                v-model='image.marginBottom'
                @input='(e) => actions.handleImageListImagePropChanged(flatPage.id, item.id, image.id, "marginBottom", e)'
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <label class='mt-3 mb-0'>Link</label>
              <b-form-input
                v-model='image.link'
                @input='(e) => actions.handleImageListImagePropChanged(flatPage.id, item.id, image.id, "link", e)'
              />
            </b-col>
          </b-row>

          <b-row class='mt-2'>
            <b-col>
              <b-form-file
                accept=".jpg, .png, .gif, .jpeg"
                @change='(e) => imageUploaded(e, image)'
                size='sm'
                placeholder='wybierz plik'
              />
            </b-col>
          </b-row>
        </div>

      </b-col>  
    </b-row>  
  </div>  
</template>

<script>
  import {
    handleAddImageToList,
    handleRemoveImageFromList,
    handleChangeImageInList,
    handleMoveImageLeftInImageList,
    handleMoveImageRightInImageList,
    handleImageListImagePropChanged,
    handleImageListValueChanged,
  } from '@/store/utils.js'

  import {
    BIconTrash,
    BIconCaretLeftFill,
    BIconCaretRightFill,
  } from 'bootstrap-vue'

  import { mediaROOT } from '@/api'

  export default {
    props: ['flatPage', 'item'],
    components: {
      BIconTrash,
      BIconCaretLeftFill,
      BIconCaretRightFill,
    },
    mounted() {
      console.log('IMAGE LIST MOUNTED', this.item)
    },
    data() {
      return {
        mediaROOT: mediaROOT,
        removeImageFromList: false,
        imageToRemove: null,
        actions: {
          handleAddImageToList,
          handleRemoveImageFromList,
          handleChangeImageInList,
          handleMoveImageLeftInImageList,
          handleMoveImageRightInImageList,
          handleImageListImagePropChanged,
          handleImageListValueChanged,
        },
      }
    },
    methods: {
      imageSrc(image) {
        if (image.base64 != null) return image.base64
        if (image.url != null) return mediaROOT + "/" + image.url

        return false
      },
      readerLoad(base64, image){
        this.actions.handleChangeImageInList(
          this.flatPage.id,
          this.item.id,
          image.id,
          base64
        )
      },
      imageUploaded(e, image) {
        
        const file = e.target.files[0]
        const reader = new FileReader()

        if (file) reader.readAsDataURL(file)

        const onReaderLoad = this.readerLoad.bind(this)
        reader.addEventListener('load', () => onReaderLoad(reader.result, image), false)
      }
    },
  }
</script>

<style>
  .image-container {
    border: 1px solid silver;
    border-radius: 8px;
    padding: 7px;
    margin: 5px;
  }
  .image-wrapper {
    height: 120px;
  }
</style>